//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { filter , map } from 'lodash'

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const tipsBookInitial = [];

export const tipsBook = (state = tipsBookInitial, action) => {
    switch (action.type) {
        case ActionTypes.tips.listTipsBookSuccess:
            return Array.isArray(action.payload) ? action.payload : [];
        case ActionTypes.tips.listTipsBookFail:
            return Array.isArray(state) ? state : [];
        case ActionTypes.tips.createTipsBookSuccess:
            return Array.isArray(state) ? [action.payload, ...state] : [action.payload];
        case ActionTypes.tips.updateTipsBookSuccess:
            return Array.isArray(state) ? map(state,st=>(st.id==action.payload.id?action.payload:st)) : [action.payload];
        case ActionTypes.tips.deleteTipsBookSuccess:
            return Array.isArray(state) ? filter(state,st=>st.id!=action.payload) : [];
        default:
            return Array.isArray(state) ? state : [];
    }
};